export const GEO_API_KEY = "AIzaSyBqf1S_FdFwlnh63ZTXH7g4Aj7fed5Avnk";
